import React from 'react';
import { PriceBlock } from '@hpi-sox/hpstellar-core';
import { PriceBlockUs } from '@hpi-sox/hpstellar-core/visId';

import { useGetProductPrice } from '../../../hooks/useProductPrice';
import { Helpers } from '../../../core/src/helpers';

export default ({ product, priceBlockProps = {}, visid }) => {
    const price = useGetProductPrice(product, { transformPriceProps: true });

    if (visid) {
        const oldPrice =
            price?.regularPrice !== price?.salePrice ? Helpers.formatCurrency(price?.regularPrice, '$', true) : null;
        const finalPrice = Helpers.formatCurrency(price?.salePrice, '$', true);
        const saveLabel = price?.customSaleText && <span className="priceDifference-gfe">{price?.customSaleText}</span>;

        return (
            <div className="price-container">
                {price && (
                    <PriceBlockUs
                        finalPriceTypographyVariant="subtitle"
                        {...price}
                        saveLabel={saveLabel}
                        oldPrice={oldPrice}
                        finalPrice={finalPrice}
                    />
                )}
            </div>
        );
    }
    return <div className="price-container">{price && <PriceBlock {...price} {...priceBlockProps} />}</div>;
};
